import { Observable } from "rxjs/Observable"
import { push } from "connected-react-router"
import urls from "data/router/urls"
import { selectPathname } from "data/router/selectors"
import { selectRedirectCallback } from "data/app/selectors"
import { onSearchPage, onAffiliatePage } from "data/router/helpers"
import { noopAction } from "common/redux/actions"
import { purgeEverything } from "global/apolloClient"
import { identifyUser } from "analytics/user/analyticsTraits"
import { logoutFinished } from "./actions"
import { onProductPage ,onProductsPage, onReservePage } from "../router/helpers";

const loginEpic = (action$, store) =>
  action$
    .ofType("USER/LOGIN")
    .map(({ payload }) => {
      const storeState = store.getState()

      const path = selectPathname(storeState)
      identifyUser(payload)

      if (!onSearchPage(path) && !onAffiliatePage(path) &&
          !onProductPage(path) && !onProductsPage(path) &&
          !onReservePage(path)) {
        return push(`${urls.home}${window.location.search}`)
      }

      const redirectCallback = selectRedirectCallback(storeState)

      // TODO: ideally a push shouldn't forced here, but rather a noop action
      // due to a react-apollo issue (#3425) with does not update network status correctly
      // this will be kept like this until it's fixed and we update the react-apollo version
      // store.dispatch in rxJS middleware is going to be deprecated as it shouldn't be used
      // under normal circumstances
      return redirectCallback ? store.dispatch(redirectCallback()) : push(`${path}`)
    })
    .catch(() => Observable.of(noopAction()))

const logoutEpic = action$ =>
  action$
    .ofType("USER/LOGOUT")
    .switchMap(() => purgeEverything(true))
    .switchMap(() => Observable.of(push(urls.home), logoutFinished()))
    //Navigate user to the homepage and dispatch the logout completed action.
    .catch(() => Observable.of(push(urls.home), logoutFinished()))

export default [loginEpic, logoutEpic]



// WEBPACK FOOTER //
// ./src/data/user/epics.js